import { useEffect, useState } from 'react'
import Text from '@web-ui-kit/text'
import Link from '@web-ui-kit/link'
import { Trans, useTranslation } from 'react-i18next'
import { TYPES_DEVICES } from 'utils/constants'
import { checkDeviceIsTabletOrMobile } from 'utils'
import BannerHeader from 'components/BannerHeader'

const BannerEdubookApp = () => {
  const { t } = useTranslation()
  const currentDevice = checkDeviceIsTabletOrMobile()
  const [displayBanner, setDisplayBanner] = useState(false)

  useEffect(() => {
    if (currentDevice) {
      setDisplayBanner(true)
    }
  }, [currentDevice])

  const handleClickDownload = () => {
    window.open(
      currentDevice === TYPES_DEVICES.IOS
        ? window?.def?.apiUrlAppleStore
        : window?.def?.apiUrlPlayStore,
      '_blank'
    )
  }

  const handleCloseBanner = () => {
    const messageDownload = localStorage.getItem('messageDownload')
    const addOneToMessage = 1
    localStorage.setItem(
      'messageDownload',
      Number(messageDownload) + addOneToMessage
    )
    setDisplayBanner(false)
  }

  return (
    <BannerHeader
      closeBanner={handleCloseBanner}
      id='banner-edubook-app'
      isOpen={displayBanner}
    >
      <>
        <Text variant='body'>
          <Trans i18nKey='¿Has probado la nueva aplicación para móvil y tablet? Disfruta de EduBook sin internet y desde cualquier lugar'>
            <strong>
              ¿Has probado la nueva aplicación para móvil y tablet?
            </strong>{' '}
            Disfruta de EduBook sin internet y desde cualquier lugar.
          </Trans>
        </Text>
        <Link onClick={handleClickDownload}>{t('¡Descárgala ahora!')}</Link>
      </>
    </BannerHeader>
  )
}

export default BannerEdubookApp
